import { useCallback } from 'react';
import { getKeyOpinionHighGameGPTReport } from '@op/services/keyOpinions';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';

 
/**
 * 关键观点 GPT 报告 Hook
 *
 * 用于获取 AI 生成的 GPT 报告数据
 */
export const useGPTReport = () => {  
  const { loading, error, wrapperRequest } = useCancelRequestHook();

  /**
   * 请求 GPT 报告数据
   * 适配旧版 Service 接口格式：(payload, cancelTokenFunc) => Promise
   */
  const fetchReport = useCallback((params: any,gameInfo:any, isSteam: boolean) => {
    const { start_time, end_time, sentiment_type, date_type, channel_type } =
      params;

    const oriFilter: any = {
      start_time,
      end_time,
      sentiment_type,
      date_type,
      channel_type,
      page_source: 'pc_opinion',
      ...gameInfo
    };

    if (isSteam) {
      oriFilter.has_steam_conf = true;
    }

    return wrapperRequest((cancelFunc: any) =>
      getKeyOpinionHighGameGPTReport(oriFilter, cancelFunc),
    );
  }, []);

  return {
    loading,
    error,
    fetchReport,
  };
};
